import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/custom-bots")({
  component: () => <Outlet />,
});
